import crud from '@/crud/form/form'
import resources from '../../resources'

import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  computed,
  methods,
  mounted,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/form/resources/index.js